module.exports = __webpack_public_path__ + "static/media/avtomatizaciya.530dd895.pdf";